export default "__VITE_ASSET__BFMiW2iW__"